<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            id="gridContainer"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'customers-grid-state', savingTimeout: 0 }"
            (onExporting)="onExporting($event)"
            (onRowUpdating)="onRowUpdating($event)"
            (onRowDblClick)="onRowDblClick($event)"
            (onInitNewRow)="onInitNewRow($event)"
            (onEditorPreparing)="onEditorPreparing($event)"
            keyExpr="id"
            width="100%"
        >
            <dxo-editing
                [mode]="'row'"
                [allowUpdating]="canManage"
                [allowAdding]="canManage"
                [allowDeleting]="canManage"
                [useIcons]="true"
            >
            </dxo-editing>
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Customers</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item *ngIf="canManage" location="after" locateInMenu="never">
                    <dx-button
                        class="ms-sm-2"
                        text="New"
                        icon="plus"
                        type="default"
                        stylingMode="contained"
                        (onClick)="addNew()"
                    ></dx-button>
                </dxi-item>
            </dxo-toolbar>
            <dxi-column [dataField]="gridFieldName('number')" caption="ID" [minWidth]="100" cellTemplate="id">
                <dxi-validation-rule type="required" message="ID is required"></dxi-validation-rule>
                <dxi-validation-rule type="stringLength" [max]="20" message="ID cannot exceed 20 characters"></dxi-validation-rule>
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('name')" caption="Name" [minWidth]="100">
                <dxi-validation-rule type="required" message="Name is required"></dxi-validation-rule>
                <dxi-validation-rule type="stringLength" [max]="100" message="Name cannot exceed 100 characters"></dxi-validation-rule>
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('address')" caption="Address" [minWidth]="100">
                <dxi-validation-rule type="required" message="Address is required"></dxi-validation-rule>
                <dxi-validation-rule type="stringLength" [max]="200" message="Address cannot exceed 200 characters"></dxi-validation-rule>
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('email')" caption="Email" [minWidth]="100" [editorOptions]="{ maxLength: 150 }">
                <dxi-validation-rule type="email" message="Email format is invalid"></dxi-validation-rule>
                <dxi-validation-rule type="stringLength" [max]="150" message="Email cannot exceed 150 characters"></dxi-validation-rule>
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('phone')" caption="Phone Number" [minWidth]="100" cellTemplate="phone"
                [editorOptions]="{ mask: '(000) 000-0000' }"></dxi-column>
            <dxi-column [dataField]="gridFieldName('status')" [lookup]="{ dataSource: customerStatusOptions, valueExpr: 'value', displayExpr: 'text' }"
                caption="Status" [filterOperations]="['=']" [headerFilter]="{ dataSource: customerStatusOptions }" [minWidth]="150" cellTemplate="status"
            >
                <dxi-validation-rule type="required" message="Status is required"></dxi-validation-rule>
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('lastModified')" caption="Last Modified" [allowEditing]="false" [minWidth]="150" cellTemplate="lastModified" [visible]="false"></dxi-column>

            <div *dxTemplate="let cellInfo of 'id'">
                <div class="text-primary fw-semibold">
                    {{ getCellData(cellInfo).number }}
                </div>
            </div>
            <div *dxTemplate="let cellInfo of 'status'">
                <span class="badge" [ngClass]="getBadgeClass(getCellData(cellInfo).status)">
                    {{ cellInfo.value | capitalCase }}
                </span>
            </div>
            <div *dxTemplate="let cellInfo of 'phone'">
                {{ getCellData(cellInfo).phone | phoneFormat }}
            </div>
            <div *dxTemplate="let cellInfo of 'lastModified'">
                {{ getCellData(cellInfo).lastModified | date:dateTimeFormat }}
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item [dataField]="filterModelName('number')"
                      editorType="dxTextBox"
                      caption="ID"
                      [editorOptions]="{placeholder: 'ID', stylingMode: 'filled'}"></dxi-item>
            <dxi-item
                [dataField]="filterModelName('name')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Name', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('address')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Address', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('email')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Email', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('phone')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Phone', stylingMode: 'filled', mask: '(000) 000-0000' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('status')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: customerStatusOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Status', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('lastModified')"
                editorType="dxDateBox"
                [editorOptions]="{ placeholder: 'Last Modified', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
        </dx-form>
    </filter-panel>
</div>
